export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/info', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getInfoList = async (searchText) => {
    try {
        const result = await get(`info${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getInfoContent = async (newsId) => {
    try {
        const result = await get(`info/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createInfo = async (data) => {
    try {
        const result = await post('info', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateInfo = async (id, data) => {
    try {
        const result = await put(`info/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteInfo = async (id) => {
    try {
        const result = await destroy(`info/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};
